<template>
  <div v-if="value.recipients" class="d-flex align-items-center flex-wrap" style="gap: .5rem">
    <template v-if="value.recipients.hasOwnProperty('users') && value.recipients.users.length > 1">
      <b-badge
        :id="`user-recipients-${value.id}`"
        pill
        variant="primary"
        class="p-1 px-2 recipients-large"
      >
        Usuarios
        <b-badge variant="light">
          {{value.recipients.users.length}}
        </b-badge>
      </b-badge>

      <b-popover
        :target="`user-recipients-${value.id}`"
        triggers="click"
        placement="right"
        @show="loadRecipientAvatars"
      >
        <b-avatar-group size="35px">
          <b-avatar
            v-for="(item, index) in userRecipients"
            :key="index"
            variant="primary"
            :text="item.userInitials"
            :src="item.avatar"
            v-b-popover.hover.top="item.name"
          >
          </b-avatar>
        </b-avatar-group>
      </b-popover>
    </template>
    <template v-else>
      <b-avatar
        v-for="(item, index) in userRecipients"
        size="35px"
        :key="`user-${index}`"
        variant="primary"
        :text="item.userInitials"
        :src="item.avatar"
        v-b-popover.hover.top="item.name"
      >
      </b-avatar>
    </template>

    <template v-if="value.recipients.hasOwnProperty('areas') && value.recipients.areas.length > 1">
      <b-badge
        :id="`areas-recipients-${value.id}`"
        pill
        variant="danger"
        class="p-1 px-2 recipients-large"
      >
        Areas
        <b-badge variant="light">{{value.recipients.areas.length}} <span class="sr-only">Destinatarios</span></b-badge>
      </b-badge>

      <b-popover
        :target="`areas-recipients-${value.id}`"
        triggers="click"
      >
        <b-badge v-for="(item, index) in value.recipients.areas"
        :key="index"
        pill
        class="p-1 px-2 ml-1"
        variant="danger"
        >{{item.name}}
        </b-badge>
      </b-popover>
    </template>
    <template v-else>
      <b-badge v-for="(item) in value.recipients.areas"
      :key="item.id"
      pill
      class="p-1 px-2"
      variant="danger"
      >{{item.name}}
      </b-badge>
    </template>

    <template v-if="value.recipients.hasOwnProperty('subareas') && value.recipients.subareas.length > 1">
      <b-badge
        :id="`subareas-recipients-${value.id}`"
        pill
        variant="info"
        class="p-1 px-2 recipients-large"
      >
        Subáreas
        <b-badge variant="light">{{value.recipients.subareas.length}} <span class="sr-only">Destinatarios</span></b-badge>
      </b-badge>

      <b-popover
        :target="`subareas-recipients-${value.id}`"
        triggers="click"
        placement="right"
      >
        <b-badge v-for="(item) in value.recipients.subareas"
        :key="item.id"
        pill
        class="p-1 px-2 ml-1"
        variant="info"
        >{{item.name}}
        </b-badge>
      </b-popover>
    </template>
    <template v-else>
      <b-badge v-for="(item) in value.recipients.subareas"
      :key="item.id"
      pill
      class="p-1 px-2"
      variant="info"
      >{{item.name}}
      </b-badge>
    </template>

    <template v-if="value.recipients.hasOwnProperty('groups') && value.recipients.groups.length > 1">
      <b-badge
        :id="`groups-recipients-${value.id}`"
        pill
        variant="warning"
        class="p-1 px-2 recipients-large"
      >
        Grupos
        <b-badge variant="light">{{value.recipients.groups.length}} <span class="sr-only">Destinatarios</span></b-badge>
      </b-badge>

      <b-popover
        :target="`groups-recipients-${value.id}`"
        triggers="click"
        placement="right"
      >
        <b-badge v-for="(item) in value.recipients.groups"
        :key="item.id"
        pill
        class="p-1 px-2 ml-1"
        variant="warning"
        >{{item.name}}
        </b-badge>
      </b-popover>
    </template>
    <template v-else>
      <b-badge v-for="(item) in value.recipients.groups"
      :key="item.id"
      pill
      class="p-1 px-2"
      variant="warning"
      >{{item.name}}
      </b-badge>
    </template>

    <template v-if="value.recipients.hasOwnProperty('emails') && value.recipients.emails.length > 1">
      <b-badge
        :id="`emails-recipients-${value.id}`"
        pill
        variant="success"
        class="p-1 px-2 recipients-large"
      >
        Mails
        <b-badge variant="light">{{value.recipients.emails.length}} <span class="sr-only">Destinatarios</span></b-badge>
      </b-badge>

      <b-popover
        :target="`emails-recipients-${value.id}`"
        triggers="click"
        placement="right"
      >
        <b-badge v-for="(item) in value.recipients.emails"
        :key="item.name"
        pill
        class="p-1 px-2 ml-1"
        variant="success"
        >{{item.name}}
        </b-badge>
      </b-popover>
    </template>
    <template v-else>
      <b-badge v-for="(item) in value.recipients.emails"
      :key="item.name"
      pill
      class="p-1 px-2"
      variant="success"
      >{{item.name}}
      </b-badge>
    </template>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      userRecipients: [],
      expandUserAvatars: true
    }
  },
  methods: {
    async loadRecipientAvatars () {
      if (this.expandUserAvatars) {
        for (const item of this.value.recipients.users) {
          const res = await commonsApi.axiosGetWrapper(`/users/user-meta/${item.id}`)
          const userInfo = res.data
          const avatar = {
            name: `${userInfo.firstname} ${userInfo.lastname}`,
            userInitials: res.data?.userInitials,
            avatar: userInfo?.profilePicture || ''
          }
          this.userRecipients.push(avatar)
        }
        this.expandUserAvatars = false
      }
    }
  },
  async created () {
    if (this.value.recipients?.users?.length <= 3) {
      try {
        await this.loadRecipientAvatars()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.recipients-large
  cursor: pointer
</style>
